/* Custom JS */

document.addEventListener("DOMContentLoaded", () => {
	const blueButton = document.querySelector(".blue-wp-button");
	const blackButton = document.querySelector(".black-wp-button");
	const params = new URLSearchParams(window.location.search);

	const leaseValue = params.get("lease");

	if (blueButton && leaseValue && leaseValue.includes("miete")) {
		blueButton.classList.add("active");
	} else if (blackButton && leaseValue && leaseValue.includes("kauf")) {
		blackButton.classList.add("active");
	}

	// Function to handle slider group logic
	function handleSliderGroup(selector) {
		const sliderGroup = document.querySelector(selector);
		const prevArrow = document.querySelector(".query-loop-swiper-button-prev");
		const nextArrow = document.querySelector(".query-loop-swiper-button-next");

		if (!sliderGroup || !prevArrow || !nextArrow) return;

		// Function to get computed content of an element
		function getComputedContent(el) {
			return window.getComputedStyle(el).getPropertyValue("content");
		}

		// Grab current content
		const prevContent = getComputedContent(prevArrow);
		const nextContent = getComputedContent(nextArrow);

		// Move arrows to the new group
		sliderGroup.appendChild(prevArrow);
		sliderGroup.appendChild(nextArrow);

		// Apply the captured content inline via a style tag
		const style = document.createElement("style");
		style.innerHTML = `
${selector} .query-loop-swiper-button-next {
    content: ${nextContent};
}
${selector} .query-loop-swiper-button-prev {
    content: ${prevContent};
}
`;
		document.head.appendChild(style);
	}

	// Apply logic to both slider groups
	handleSliderGroup(".query-loop-slider-group");
	handleSliderGroup(".query-slider-wohnbauprojekte");
});
